import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Import your translation files
import en from './en.json';
import es from './es.json';

i18n
    .use(initReactI18next) // Bind React with i18next
    .init({
        resources: {
            en: { translation: en },
            es: { translation: es },
        },
        fallbackLng: 'en', // Fallback language if no match is found
        debug: true, // Debugging information in the console
        interpolation: {
            escapeValue: false, // React already escapes values
        },
        detection: {
            order: ['querystring', 'cookie', 'localStorage', 'navigator', 'htmlTag'], // Order of language detection
            caches: ['localStorage', 'cookie'], // Where to store the detected language
        },
    });

export default i18n;
